import { Checkbox } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"

import { GoodsReceiptValueOrMultiple, PurchaseOrderQuantityPalletsCell } from "../../../components"

import { PurchaseOrderNumberCell } from "@/components/table"
import type { Order } from "@/graphql/codegen/graphql"
import { getLocationWarehousesPrefix } from "@/screens/Procurement/PurchaseOrder/utils/common"
import { getPurchaseOrderContainerTrackingNumbers } from "@/screens/WarehouseReceiving/utils"

export const usePurchaseOrderSelectionTableColumns = (): ColumnDef<Order>[] => [
  {
    id: "select",
    header: "",
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        indeterminate={row.getIsSomeSelected()}
        onChange={row.getToggleSelectedHandler()}
        disabled={!row.getCanSelect()}
        data-testid={`po-select-checkbox-${row.original.orderId}`}
      />
    ),
    size: 50,
  },
  {
    accessorKey: "orderId",
    header: "PO #",
    cell: ({ row }) => <PurchaseOrderNumberCell order={row.original} />,
  },
  {
    accessorKey: "shipToLocation",
    header: "Ship To",
    cell: ({ row }) => {
      const { warehouse, destinationLocationAssociationDetail } = row.original
      const shippingLocation =
        destinationLocationAssociationDetail?.companyLocationAssociation?.shippingLocationDetail?.location

      return (
        shippingLocation &&
        `${warehouse ? warehouse.externalSystemId : getLocationWarehousesPrefix(shippingLocation)} ${shippingLocation.description}`
      )
    },
  },
  {
    accessorKey: "containerTrackingNumber",
    header: "Container/Tracking",
    cell: ({ row }) => <GoodsReceiptValueOrMultiple values={getPurchaseOrderContainerTrackingNumbers(row.original)} />,
  },
  {
    accessorKey: "quantityOrdered",
    header: "Quantity Ordered",
    cell: ({ row }) => <PurchaseOrderQuantityPalletsCell order={row.original} />,
  },
  {
    accessorKey: "supplierName",
    header: "Supplier Name",
    cell: ({ row }) => <span>{row.original.orderLines?.[0]?.product?.company?.name}</span>,
  },
]
